import { render, staticRenderFns } from "./CommunityHomePopup.vue?vue&type=template&id=6e15d80c&scoped=true"
import script from "./CommunityHomePopup.vue?vue&type=script&lang=js"
export * from "./CommunityHomePopup.vue?vue&type=script&lang=js"
import style0 from "./CommunityHomePopup.vue?vue&type=style&index=0&id=6e15d80c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15d80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e15d80c')) {
      api.createRecord('6e15d80c', component.options)
    } else {
      api.reload('6e15d80c', component.options)
    }
    module.hot.accept("./CommunityHomePopup.vue?vue&type=template&id=6e15d80c&scoped=true", function () {
      api.rerender('6e15d80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/popupWindows/components/CommunityHomePopup.vue"
export default component.exports